import { useMemo, useCallback } from "react";

export function DurationPills({
  show,
  options,
  selected,
  onToggle,
  className,
}) {
  if (!show) return null;

  const selectedSet = useMemo(() => new Set(selected), [selected]);
  const safeOptions = useMemo(
    () => (Array.isArray(options) ? options.filter(Boolean) : []),
    [options]
  );
  const handleToggle = useCallback((v) => onToggle(v), [onToggle]);

  return (
    <div className={className ?? "c-tag_body_from"}>
      {safeOptions.map((dur) => {
        const isSelected = selectedSet.has(dur.value);
        return (
          <button
            type="button"
            key={dur.value}
            style={{ 
              border: "none"
            }}
            className={`c-tag_body_from-input ${isSelected ? "selected" : ""}`}
            onClick={() => handleToggle(dur.value)}
            aria-pressed={isSelected}
          >
            {dur.label}
          </button>
        );
      })}
    </div>
  );
}

